import OngoingOrder from './OngoingOrder';
import OrderPaymentBreakdown from './OrderPaymentBreakdown';
import OrderRating from './OrderRating';
import OrderTimeline from './OrderTimeline';
import OrderTracker from './OrderTracker';
import PickupTimeChangedNotice from './PickupTimeChangedNotice';

export default {
  OngoingOrder,
  OrderPaymentBreakdown,
  OrderRating,
  OrderTimeline,
  OrderTracker,
  PickupTimeChangedNotice,
};
